import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  IAllocatorDataProps,
  IMyAllocatorInitialState,
} from 'redux/saga/lenders/Allocator.types';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { APIStatus } from '../../../services/api/apiStatusCode';
import { IActionPayload } from '../../types/UserPermission.types';

export const rejectedLendersInitialState: IMyAllocatorInitialState = {
  status: APIStatus.INIT,
  lenderData: [],
  isLoading: false,
  error: {},
};

const rejectedLenderSlice = createSlice({
  name: 'rejectedLenders',
  initialState: rejectedLendersInitialState,
  reducers: {
    fetchRejectedAllocator: (
      state,
      action: PayloadAction<AllocatorListPayload>
    ) => {
      state.isLoading = true;
      state.status = APIStatus.PENDING;
    },
    fetchRejectedAllocatorSucceeded: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IAllocatorDataProps[]>
    ) => {
      state.lenderData = action.payload;
      state.isLoading = false;
      state.status = APIStatus.SUCCESS;
    },
    fetchRejectedAllocatorFailed: (
      state: IMyAllocatorInitialState,
      action: PayloadAction<IActionPayload>
    ) => {
      const { error } = action.payload;
      state.error = error;
      state.isLoading = false;
      state.status = APIStatus.ERROR;
    },
    resetRejectedLenderState: () => rejectedLendersInitialState,
  },
});

export const {
  fetchRejectedAllocator,
  fetchRejectedAllocatorSucceeded,
  fetchRejectedAllocatorFailed,
  resetRejectedLenderState,
} = rejectedLenderSlice.actions;

export default rejectedLenderSlice.reducer;
